import {
    findIconDefinition,
    IconName,
    IconPrefix,
} from '@fortawesome/fontawesome-svg-core';
import { ITextBoolean, IValueText } from '../../models/constants';
import { IServiceRequestOptions } from '../../models/service-request';
import { IShippingMethodOptions } from '../../models/shipping';
import { IOption } from '../inputs/select-input-simple';

export const findIcon = (prefix: IconPrefix, icon: IconName) => {
    return findIconDefinition({
        prefix: prefix,
        iconName: icon,
    });
};

export enum CartItemTypes {
    BteOnly = 1,
    RicWithStockReceiver = 2,
    CustomOnly = 3,
    Earmold = 4,
    BteWithEarmold = 5,
    RicWithEarmold = 6,
    ApReceiver = 7,
    RicWithAp = 8,
    FacePlates = 9,
    RicWithChr = 10,
    AMP = 30,
    Accessory = 40,
    Supply = 50,
    StockReceiver = 55,
    SparePart = 60,
    Literature = 70,
    SoundGear = 80,
    SoundGearCustom = 83,
    SoundGearEarmold = 84,
    DashTailored = 85,
}
export enum ReceiverType {
    NonSnapFit = 0,
    SnapFit = 1,
    SnapFit2 = 2,
}

export const leftCableLengthIdsNew = {
    val1: 1319,
    val2: 1320,
    val3: 1321,
    val4: 1322,
    val5: 1323,
};

export const leftCableLengthIdsOld = {
    val1: 1299,
    val2: 1300,
    val3: 1301,
    val4: 1302,
    val5: 1303,
};
export const APIDs = [510, 511, 595, 596, 1308, 1309];

export const APCustomCasedDesignIDs: number[] = [37, 39, 40, 7844, 9195, 9189];

export const gainMessageIDs = [168, 1291, 1296];

export const G23Gains: string[] = ['L-', 'L', 'M', 'UP-', 'UP'];

export const GainValues: IOption[] = [
    {
        value: '35',
        text: 'L-',
    },
    {
        value: '40',
        text: 'L',
    },
    {
        value: '50',
        text: 'M',
    },
    {
        value: '60',
        text: 'P',
    },
    {
        value: '65',
        text: 'UP-',
    },
    {
        value: '70',
        text: 'UP',
    },
];

export const thresholds: string[] = [
    '250',
    '500',
    '750',
    '1k',
    '1.5k',
    '2k',
    '3k',
    '4k',
    '6k',
    '8k',
];
export const patientAges: IValueText[] = [
    { value: 'Under 18', text: 'Under 18' },
    { value: '18-25', text: '18-25' },
    { value: '26-35', text: '26-35' },
    { value: '36-45', text: '36-45' },
    { value: '46-55', text: '46-55' },
    { value: '56-65', text: '56-65' },
    { value: '66-75', text: '66-75' },
    { value: '76-85', text: '76-85' },
    { value: 'Over 85', text: 'Over 85' },
];

export const canalTextures: IValueText[] = [
    { value: 'Normal', text: 'Normal' },
    { value: 'Soft', text: 'Soft' },
    { value: 'Hard', text: 'Hard' },
    { value: 'Rigid', text: 'Rigid' },
    { value: 'Unknown', text: 'Unknown' },
];
export const previousVenting: IValueText[] = [
    {
        text: 'Large',
        value: 'Large',
    },
    {
        text: 'Small',
        value: 'Small',
    },
    { text: 'None', value: 'None' },
];
export const yesNo: ITextBoolean[] = [
    {
        text: 'Yes',
        value: true,
        english: 'Yes',
    },
    {
        text: 'No',
        value: false,
        english: 'No',
    },
];

export const shippingMethodOptions: IShippingMethodOptions[] = [
    {
        shippingMethod: 'First Class Mail With Tracking 1-3 Days',
        defaultShippingMethodCode: '000001_MAIL_P_FCM',
    },
    {
        shippingMethod: 'Ground, 1-5 days intransit depending on zone',
        defaultShippingMethodCode: '000001_GROUND_P_GND',
    },
    {
        shippingMethod: 'Overnight, next day delivery',
        defaultShippingMethodCode: '000001_AIR_A_ON1',
    },
    {
        shippingMethod: 'Second Day Air',
        defaultShippingMethodCode: '000001_AIR_A_2DA',
    },
    {
        shippingMethod: 'Overnight, next day by 10:30',
        defaultShippingMethodCode: '000001_AIR_A_ON2',
    },
];

export const serviceRequestTypes: IServiceRequestOptions[] = [
    {
        text: 'Select ...',
        value: 'Select ...',
        url: '/my-account/online-forms/service-request/',
    },
    {
        text: 'Repair',
        value: 'Repair',
        url: '/my-account/online-forms/service-request/repair',
    },
    {
        text: 'Return for Credit',
        value: 'Return for Credit',
        url: '/my-account/online-forms/service-request/return-for-credit',
    },
    {
        text: 'Color Exchange',
        value: 'Color Exchange',
        url: '/prosite/my-account/online-forms/service-request/color-exchange',
    },
];

export const impressionsCartItemTypes = [
    CartItemTypes.CustomOnly,
    CartItemTypes.BteWithEarmold,
    CartItemTypes.RicWithEarmold,
    CartItemTypes.RicWithAp,
    CartItemTypes.ApReceiver,
    CartItemTypes.Earmold,
    CartItemTypes.SoundGearEarmold,
    CartItemTypes.SoundGearCustom,
];
export const BS = {
    Primary: 'primary',
    Danger: 'danger',
    Info: 'info',
};

export enum earmoldCategory {
    Standard = 'Standard Earmold',
    RIC = 'RIC Earmold',
    ThinTube = 'Thin Tube Earmold',
    Earplug = 'Earplug Earmold',
    Specialty = 'Specialty Earmold',
}

export const ME_CHARGER_OPTIONS_ID = 67;
export const CHARGER_OPTIONS_ID = 68;
export const ACO_CHARGER_OPTIONS_ID = 73;
export const CHARGER_OPTIONS_ID_LIST = [68, 73];
export const RECEIVER_GAIN_OPTIONS_ID = 19;
export const STOCK = 'STOCK';
export const STOCK_COMMA = 'STOCK, ';
export const HEARING_AID_ORDER = 'Hearing Aid Order';
export const COMMON_SUPPLY_ORDER = 'Common Supply Order';
export const REPAIR_REMAKE_LD = 'Repair, Remake or L&D';
export const ORDER_STATUS_TESTING = 'Testing';
export const ORDER_STATUS_SHIPPED = 'Shipped';
export const NEED_TO_MAKE_CHANGES_TO_ORDER =
    'Need to make changes to your order?';
export const NEED_CHANGES_IN_ORDER_ID = 'Need_to_make_changes_to_your_order';
export const ORDER_DETAILS_TOOLTIP =
    'Updates to this order are subject to status and product availability and may not always be available.';
export const ORDER_DETAILS_TOOLTIP_ID = 'Tooltip_Order_Details';
export const REPORT_LOSS_DAMAGE = 'Report Lost or Damaged Item(s)';
export const REPORT_LOSS_DAMAGE_ID = 'Report_Lost_or_Damaged_Item(s)';
export const STANDARD_ORDER_AID = 'Standard Order Aid';
export const STARKEY = 'Starkey';
export const AUDIKA = 'Audika';
export const AUDIBEL = 'Audibel';
export const AMPLIFON = 'Amplifon';
export const MICROTECH = 'MicroTech';
export const AUDIGY = 'Audigy';
export const NUEAR = 'NuEar';
export const MIRACLEEAR = 'MIRACLE EAR';
export const TELEFUNKEN = 'Telefunken';
export const KIND = 'KIND';
export const PROAKUSTIK = 'Pro Akustik';
export const MIRACLEEAR_LOWER = 'Miracle-Ear';
export const BATTERY_PRODUCT_TYPE = 'Rechargeable Accessories';
export const G23_RECEIVER_TYPE = 'SnapFit2';
export const STANDARD_EARMOLD_TYPE = 'Standard Earmold';
export const MATERIAL_HHS_OPTIONS_IDS = [833, 835];
export const MATERIAL_OPTION_TYPE_ID = 30;

export const G23Countries = ['US', 'CA', 'FR', 'DE', 'KR'];
export const noChargerValidationCountries = ['FR', 'DE'];
export const chargerMultiOptionCountries = ['FR'];
export const noWarrantyCountries = ['FR', 'KR', 'DE'];
export const noAgreementCountries = ['FR', 'KR', 'DE'];
export const countriesOldAccessories = ['FR', 'KR', 'CA', 'DE'];

//constants for each country - start
export const US = 'US';
export const FR = 'FR';
export const KR = 'KR';
export const CA = 'CA';
export const DE = 'DE';
export const IT = 'IT';

export const CA_FR_LANG = 'Canadian French';
export const KR_LANG = 'Korean';

export const DE_LANG = 'German';
export const EN_LANG = 'English';
//constants for each country - end

export const ITEM_STATUS_ENTERED = 'entered';

export enum Status {
    ENTERED = 'entered',
    BOOKED = 'booked',
    AWAITING_SHIPPING = 'awaiting_shipping',
    AWAITING_FULFILLMENT = 'awaiting_fulfillment',
    CANCELLED = 'cancelled',
    SHIPPED = 'shipped',
    DELIVERED = 'delivered',
    AWAITING_RETURN = 'awaiting_return',
}

export const PLACED_BY = 'Placed_by';
export const PLACED_ON = 'Placed_on';
export const ORDER_NUM = 'Order_#';
export const VIEW_ALL_ORDERS_ID = 'View_All_Orders';
export const VIEW_ALL_ORDERS = 'View All Orders';
export const EXPECTED_SHIP_DATE_ID = 'Expected_Ship_Date';
export const EXPECTED_SHIP_DATE = 'Expected Ship Date';
export const UNAVAILABLE_ID = 'Unavailable_as_we_make_enhancements';
export const UNAVAILABLE = 'Unavailable as we make enhancements';

export const SHIPPED_DATE_ID = 'Shipped_Date';
export const SHIPPED_DATE = 'Shipped Date';
export const TRACK_SHIPMENT_ID = 'Track_Shipment';
export const TRACK_SHIPMENT = 'Track Shipment';
export const SHIPPING_METHOD_ID = 'Shipping_Method';
export const SHIPPING_METHOD = 'Shipping Method';
export const SELECT_ITEM_ID = 'Please_make_a_selection';
export const SELECT_ITEM = 'Please make a selection';
export const MANUFACTURER_SELECT_ID = 'Manufacturer_Select';
export const MANUFACTURER_SELECT = 'Manufacturer Select';
export const DO_YOU_ID = 'Do_you_want_us_to_choose_the_best_options_for_you?';
export const DO_YOU = 'Do you want us to choose the best options for you?';
export const DO_YOU_TT =
    'Selects the optimal combination of receiver and vent based on hearing loss, patient history, and size and shape of the ear.';
export const DO_YOU_TT_ID = 'Selects_the_optimal';
export const PREMIUM_CHARGER_PNS = ['43079-1DT', '43080-1DT'];
export const CHARGERS_OPTION_TYPE_ID = 1032;
export const ME_CHARGERS_OPTION_TYPE_ID = 1029;
export const CABLE_LENGTH_IDS = [1302, 1303];
export const SHIP_DATE_ID = 'Ship_Date';
export const SHIP_DATE = 'Ship Date';
export const MANAGE_ORDER_ID = 'Manage_Order';
export const MANAGE_ORDER = 'Manage Order';
export const CANNOT_UPATE_ID = 'One_or_more_cannot';
export const CANNOT_UPDATE =
    'One or more of your items below cannot be updated. You can still';
export const NO_CHARGER = 'No Charger';

export const CANCEL = 'cancel';
export const REORDER_ID = 'Cancel_and_Reorder';
export const REORDER = 'this order and reorder the correct items.';

export const ORDERING = 'Ordering';
export const PROCESSING = 'Processing';
export const SHIPPING = 'Invoicing';
export const OUT_FOR_DELIVERY = 'Out for Delivery';
export const OUT_FOR_DELIVERY_ID = 'Out_for_Delivery';
export const COMPLETED = 'Completed';
export const IN_PROGRESS = 'In Progress';
export const IN_PROGRESS_ID = 'In_Progress';
export const CANCELLED = 'Cancelled';
export const RECEIVERS_MAX_REST = 'Receivers quantity cannot exceed 500';
/*Task 95491 Stock receivers quantity per item cannot exceed 150*/
export const RECEIVERS_MAX_USCAFR =
    'Receivers quantity per item cannot exceed 150';
export const RECEIVER_OPTIONS = `Receiver Options`;
export const RECEIVER_LESS_OR_EQUAL_TO =
    'The number of receivers should be less than or equal to your total bulk quantity';
export const VIEW_DETAIL = 'View Detail';
export const VIEW_DETAIL_ID = 'View_Detail';
export const EXCEPTION = 'Exception';
export const NO_AVAIABLE = 'No Messages Available';
export const NO_AVAILABLE_ID = 'No_Messages_Available';
export const PDFSURL = '/pdfs/ordering/';
export const ESTORE_INSTRUCTION_URL = '/pdfs/ordering/eStore_Instructions.pdf';
export const noReceiverOption = 10;
export const STARKEY_US_SITE = 1;
export const AUDIBEL_US_SITE = 2;
export const NUEAR_US_SITE = 3;
export const MIRACLEEAR_US_SITE = 12;
export const USER_ROLE_ERROR =
    'Your role is unable to perform this action. Please ask a manager for assistance.';

export const NEW_INDICATOR_COOKIE = 'new_indicator';

export const ACCESSORY_GUIDE_COUNTRIES = [US, FR, IT, CA, DE, KR];
export const ACCESSORY_GUIDE_BRANDS = [STARKEY, AUDIBEL];

export const RECEIVER_PRODUCT_GUIDE_COUNTRIES = [US, FR, IT, CA];
export const NO_BATTERY_MESSAGE_COUNTRIES = [FR];
export const PRODUCT_FORM_BRANDS_DE = [NUEAR, AUDIBEL];
export const RECEIVER_PRODUCT_GUIDE_BRANDS = [
    STARKEY,
    AUDIBEL,
    AUDIGY,
    MIRACLEEAR,
    NUEAR,
];
export const RECEIVER_GAIN_NAME = 'Receiver Gain';

export const INSPIRE_LINK_TYPE = 1;
export const PRO_FIT_LINK_TYPE = 2;

export const MATRIX_OPTIONS_ID = 9;
export const CROS_SYSTEM_OPTIONS_ID = 39;
export const LARGER_STYLE_ID = 1359;
export const POWER_ADAPTER_PART_NUMBER = '43092-003';

export const CONTACTUS_AUDIBEL =
    'https://www.audibelpro.com/get-help/contact-us';
export const CONTACTUS_STARKEY =
    'https://www.starkeypro.com/get-help/contact-us';

// WIll be used when we have international sites
// export const CONTACTUS_DE =
//     'https://www.starkeypro.de/hilfe-bekommen/kontaktieren-sie-uns';
// export const CONTACTUS_FR =
//     'https://www.starkeypro.fr/obtenir-aide/nous-contacter';
// export const CONTACTUS_KR = 'https://www.starkeypro.co.kr/get-help/contact-us';

export const FAMILY = 'Family';

export const PRO_FIT_DESCRIPTION = `Architected from the ground up based on input from hearing care professionals around the globe and at every step, Pro Fit brings a new, best-in-class fitting experience to you and your patients. Enhanced with several industry firsts, it was designed for efficiency, ease of use and a seamless fitting experience — from first fit to fine tuning.`;
export const INSPIRE_DESCRIPTION = `Every patient's hearing needs are unique. With Inspire X, you have a personal, accurate way to fit your patients with {0}’s Prescriptive Fitting Package including a Feedback-Free Start, Multi-Channel Speech Optimization, Dedicated Music Compressor, Hearing Reality Pro, REM Target Match and Multiflex Tinnitus Pro.`;
export const ENTER = 'Enter';
export const keyStr =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
export const USE_DIGITAL_IMPRESSIONS_ON_FILE =
    'Use digital impressions on file';

export const MONTHS_FRENCH_CAPITAL = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
];

export const IMPRESSIONS_OPTIONS = [
    {
        id: 'Send_Physical_Impressions',
        defaultMessage: 'Send physical impressions',
    },
    {
        id: 'Use_Digital_Impressions_On_Fil',
        defaultMessage: 'Use digital impressions on file',
    },
    {
        id: 'Direct_ear_scan',
        defaultMessage: 'Direct ear scan',
    },
    {
        id: 'Attach_Digital_Impressions',
        defaultMessage: 'Attach digital impressions',
    },
];
